'use client';

import { useEffect } from 'react';

import { pushGTMEvent } from '@/utils/pushGTMEvent';

interface Props {
  resultCount: number;
  pageType: string;
  query: string;
}

export const TrackSearch = ({ pageType, query, resultCount }: Props) => {
  useEffect(() => {
    pushGTMEvent({
      event: 'search',
      search_term: query,
      search_results: resultCount,
      page_type: pageType,
    });
  }, [resultCount, pageType, query]);

  if (!query) {
    return null;
  }

  return null;
};
